import { createCRUDEndpoints } from '@/api/factory/crud';
import { SendGridEmailJSON } from '@/store/modules/sendgrid_emails/sendgrid_email';
import httpClient from '../http-client';
import { RequestConfig } from '../types';

type ListParams =
  | {
      search?: string;
      email_type?: string;
      status?: string;
      from?: string;
      to?: string;
      page?: string | number;
      sort?: string;
      direction?: string;
    }
  | undefined;

type SummaryParams =
  | {
      email_type?: string;
      from?: string;
      to?: string;
    }
  | undefined;

export interface SendGridEmailSummaryJSON {
  sends: number;
  delivered: number;
  unique_opens: number;
  unique_clicks: number;
  total_opens: number;
  total_clicks: number;
  delivered_rate: number;
  open_rate: number;
  click_rate: number;
}

export const { list, get, store, remove } = createCRUDEndpoints<SendGridEmailJSON, ListParams>({
  slug: 'sendgrid_email',
});

export function summary(params?: SummaryParams, config?: RequestConfig) {
  return httpClient.get<SendGridEmailSummaryJSON>('sendgrid_emails/summary', { params, ...config });
}
